import { render, staticRenderFns } from "./statusEditTabInformation.vue?vue&type=template&id=b798bd06&scoped=true&"
import script from "./statusEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./statusEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./statusEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b798bd06",
  null
  
)

export default component.exports